import { useGlobalForm } from '../contexts';
import { useSource } from '../hooks';
import { useFormContext } from 'react-hook-form';

/**
 * Récupère la liste des emails de l'apporteur (comptabilité, gestion, principal, sinistre, vente).
 */
function getApporteurEmails(others: any): string[] {
    const emails: (string | undefined)[] = [];

    for (const apporteur of [others?.apporteur, others?.apporteur1, others?.apporteur2]) {
        if (!apporteur) continue;
        emails.push(
            apporteur.emailComptabilite,
            apporteur.emailGestion,
            apporteur.emailPrincipal,
            apporteur.emailSinistre,
            apporteur.emailVente,
        );
    }

    return emails.filter((e): e is string => !!e).map((e) => e.toLowerCase());
}

/**
 * Hook qui retourne l'état de blocage courtier email et la fonction de validation.
 */
export function useCourtierEmailBlock() {
    const { isCourtier } = useSource();
    const { others } = useGlobalForm();
    const apporteurEmails = getApporteurEmails(others);
console.log('isCourtier', isCourtier);
console.log('others', others);
console.log('apporteurEmails', apporteurEmails);
    const validateNotCourtierEmail = (value: string) => {
        if (!isCourtier || apporteurEmails.length === 0) return true;
        if (apporteurEmails.includes(value?.toLowerCase())) {
            return "Veuillez saisir l'adresse e-mail de votre client";
        }
        return true;
    };

    return { isCourtier, apporteurEmails, validateNotCourtierEmail };
}

interface CourtierEmailWarningProps {
    emailFieldName?: string;
}

/**
 * Affiche un avertissement visuel + bloque la soumission quand un courtier
 * saisit l'email de son cabinet à la place de l'email de son client.
 */
export function CourtierEmailWarning({
    emailFieldName = 'DemandeTarif.ListePersonnes.0.Email',
}: CourtierEmailWarningProps) {
    const { isCourtier, apporteurEmails } = useCourtierEmailBlock();
    const methods = useFormContext();

    const email = methods.watch(emailFieldName);

    if (!isCourtier || !email || apporteurEmails.length === 0) return null;
    if (!apporteurEmails.includes(email.toLowerCase())) return null;

    return (
        <div className="bg-amber-400 rounded-xl px-4 py-3 w-full text-sm space-y-1">
            <p className="font-bold">
                Attention, vous avez saisi l&apos;adresse e-mail de votre cabinet et non celle de votre client.
            </p>
            <p>
                Nous avons besoin de l&apos;adresse e-mail de votre client pour lui envoyer son avis d&apos;échéance,
                en votre nom, autrement que par voie postale. Cette adresse ne sera pas utilisée à des fins commerciales.
            </p>
        </div>
    );
}
